module.exports = __webpack_public_path__ + "img/stock.2a17197b.png";